/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Upcoming_CancellationInputs */

const en_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`upcoming cancellation`)
};

const de_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anstehende Abmeldung`)
};

const es_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`próxima cancelación`)
};

const fr_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`annulation à venir`)
};

const it_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancellazione imminente`)
};

const pt_br2_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancelamento próximo`)
};

const pl_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nadchodzące anulowanie`)
};

const hu_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jövőbeli lemondás`)
};

const ro_admin_dashboard_upcoming_cancellation = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anulare viitoare`)
};

/**
* | output |
* | --- |
* | "upcoming cancellation" |
*
* @param {Admin_Dashboard_Upcoming_CancellationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_upcoming_cancellation = /** @type {((inputs?: Admin_Dashboard_Upcoming_CancellationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Upcoming_CancellationInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_upcoming_cancellation(inputs)
	if (locale === "de") return de_admin_dashboard_upcoming_cancellation(inputs)
	if (locale === "es") return es_admin_dashboard_upcoming_cancellation(inputs)
	if (locale === "fr") return fr_admin_dashboard_upcoming_cancellation(inputs)
	if (locale === "it") return it_admin_dashboard_upcoming_cancellation(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_upcoming_cancellation(inputs)
	if (locale === "pl") return pl_admin_dashboard_upcoming_cancellation(inputs)
	if (locale === "hu") return hu_admin_dashboard_upcoming_cancellation(inputs)
	return ro_admin_dashboard_upcoming_cancellation(inputs)
});
export { admin_dashboard_upcoming_cancellation as "admin.dashboard.upcoming_cancellation" }